var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerSimpleSlashRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 19v-6a1 1 0 012 0v6a1 1 0 01-2 0zm5-9a1 1 0 00-1 1v10a1 1 0 002 0V11a1 1 0 00-1-1zm-1.26 16.328a.999.999 0 11-1.48 1.345L20 21.886V28a1 1 0 01-1.614.789L9.656 22H4a2 2 0 01-2-2v-8a2 2 0 012-2h5.194L5.26 5.672a1 1 0 111.48-1.345l20 22zM18 19.686L11.012 12H4v8h6c.223 0 .439.074.614.211L18 25.955v-6.269zM14.633 8.664L18 6.039v7.309a1 1 0 002 0V4a1 1 0 00-1.614-.789l-4.981 3.875a1 1 0 001.228 1.579v-.001z"
  })));
}
export default SvgSpeakerSimpleSlashRegular;